(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-step-demo"] && !Shopify.designMode) return;
  try {
    
  class AppStepDemo extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.asd-step'));
      this.total = this.steps.length;
      if (!this.total) return;
      this.img = this.querySelector('.asd-screen img');
      this.bar = this.querySelector('[data-progress]');
      this.label = this.querySelector('[data-label]');
      this.playIcon = this.querySelector('[data-play-icon]');
      this.playLabel = this.querySelector('[data-play-label]');
      this.speed = parseInt(this.dataset.speed, 10) || 2600;
      this.loop = this.dataset.loop !== 'false';
      this.index = 0;
      this.playing = false;

      this.steps.forEach((s) => {
        s.addEventListener('click', () => this.select(parseInt(s.dataset.index, 10)));
      });
      this.querySelectorAll('[data-action]').forEach((btn) => {
        btn.addEventListener('click', () => this._act(btn.dataset.action));
      });

      this.render();
      if (this.dataset.autoplay === 'true') this.play();
    }

    disconnectedCallback() { clearInterval(this._t); }

    _act(action) {
      if (action === 'next') { this.stop(); this.index = (this.index + 1) % this.total; this.render(); }
      else if (action === 'prev') { this.stop(); this.index = (this.index - 1 + this.total) % this.total; this.render(); }
      else if (action === 'toggle') { this.playing ? this.stop() : this.play(); }
    }

    select(i) { this.stop(); this.index = i; this.render(); }

    play() {
      clearInterval(this._t);
      this.playing = true;
      this._syncPlay();
      this._t = setInterval(() => {
        if (this.index >= this.total - 1) {
          if (!this.loop) { this.stop(); return; }
          this.index = 0;
        } else {
          this.index += 1;
        }
        this.render();
      }, this.speed);
    }

    stop() { clearInterval(this._t); this.playing = false; this._syncPlay(); }

    _syncPlay() {
      if (this.playIcon) this.playIcon.textContent = this.playing ? '⏸' : '▶';
      if (this.playLabel) this.playLabel.textContent = this.playing ? 'Pause' : 'Abspielen';
    }

    render() {
      this.steps.forEach((s, i) => {
        const on = i === this.index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      const cur = this.steps[this.index];
      const src = cur.dataset.img;
      if (this.img && src) { this.img.src = src; this.img.removeAttribute('srcset'); this.img.alt = cur.dataset.alt || ''; }
      if (this.bar) this.bar.style.width = ((this.index + 1) / this.total * 100) + '%';
      if (this.label) this.label.textContent = 'Schritt ' + (this.index + 1) + ' / ' + this.total;
    }
  }
  if (!customElements.get('app-step-demo')) customElements.define('app-step-demo', AppStepDemo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bento-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wird von Shopify einmal pro Section-Typ gebündelt – egal wie viele Bento-Grids auf der Seite sind.
    if (window.__bentoZoomInit) return;
    window.__bentoZoomInit = true;

    var overlay = null;
    var lbImg = null;
    var closeBtn = null;
    var activeTrigger = null;

    // Ein einziges Overlay für die ganze Seite, lazy beim ersten Öffnen erzeugt.
    function buildOverlay() {
      overlay = document.createElement('div');
      overlay.className = 'bento-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Bildansicht');
      overlay.hidden = true;

      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'bento-lightbox__close';
      closeBtn.setAttribute('aria-label', 'Schließen');
      closeBtn.innerHTML = '&times;';

      lbImg = document.createElement('img');
      lbImg.className = 'bento-lightbox__img';
      lbImg.alt = '';

      overlay.appendChild(closeBtn);
      overlay.appendChild(lbImg);
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      closeBtn.addEventListener('click', close);
    }

    // FLIP: Bild startet exakt auf der Thumbnail-Position und wächst zur Vollansicht.
    function flipFrom(first) {
      var last = lbImg.getBoundingClientRect();
      if (!last.width || !last.height) return;
      var dx = first.left - last.left;
      var dy = first.top - last.top;
      var sx = first.width / last.width;
      var sy = first.height / last.height;
      lbImg.style.transition = 'none';
      lbImg.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
      void lbImg.offsetWidth; // Reflow erzwingen
      requestAnimationFrame(function () {
        lbImg.style.transition = '';
        overlay.classList.add('is-visible');
        lbImg.style.transform = '';
      });
    }

    function open(trigger) {
      var thumb = trigger.querySelector('img');
      if (!thumb) return;
      if (!overlay) buildOverlay();
      activeTrigger = trigger;
      var first = thumb.getBoundingClientRect();
      overlay.hidden = false;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lbImg.alt = thumb.getAttribute('alt') || '';
      // Sofort die bereits geladene Thumbnail-Quelle nutzen → flüssige Animation.
      lbImg.src = thumb.currentSrc || thumb.src;
      var start = function () {
        flipFrom(first);
        // Danach hochauflösende Variante nachladen (gleiches Seitenverhältnis, kein Sprung).
        var hi = trigger.getAttribute('data-zoom-src');
        if (hi) {
          var pre = new Image();
          pre.onload = function () {
            if (activeTrigger === trigger) lbImg.src = hi;
          };
          pre.src = hi;
        }
      };
      if (lbImg.complete && lbImg.naturalWidth) start();
      else lbImg.addEventListener('load', start, { once: true });
      closeBtn.focus();
    }

    function close() {
      if (!activeTrigger) return;
      var trigger = activeTrigger;
      var thumb = trigger.querySelector('img');
      activeTrigger = null;
      var settle = function () {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
        lbImg.style.transition = 'none';
        lbImg.style.transform = '';
        lbImg.removeAttribute('src');
        document.body.style.overflow = '';
        if (trigger) trigger.focus();
      };
      if (!thumb) {
        overlay.classList.remove('is-visible');
        settle();
        return;
      }
      var first = thumb.getBoundingClientRect();
      var last = lbImg.getBoundingClientRect();
      var dx = first.left - last.left;
      var dy = first.top - last.top;
      var sx = first.width / last.width;
      var sy = first.height / last.height;
      overlay.classList.remove('is-visible');
      lbImg.style.transition = '';
      lbImg.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        settle();
      };
      lbImg.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 420); // Fallback, falls transitionend ausbleibt
    }

    // Event-Delegation: funktioniert für alle aktuellen und nachgeladenen Bento-Grids.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-bento-zoom]');
      if (!trigger) return;
      e.preventDefault();
      open(trigger);
    });
    document.addEventListener('keydown', function (e) {
      if (!activeTrigger) return;
      if (e.key === 'Escape') {
        close();
      } else if (e.key === 'Tab') {
        // Einfacher Fokus-Trap: einziges Bedienelement ist der Schließen-Button.
        e.preventDefault();
        closeBtn.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explainer-steps"] && !Shopify.designMode) return;
  try {
    
  class ExplainerSteps extends HTMLElement {
    connectedCallback() {
      this.stepsEl = this.querySelector('[data-steps]');
      this.stepEls = Array.from(this.querySelectorAll('[data-step]'));
      this.total = this.stepEls.length;

      this.controls = this.querySelector('[data-controls]');
      this.dotsEl = this.querySelector('[data-dots]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.nextBtn = this.querySelector('[data-next]');
      this.restartBtn = this.querySelector('[data-restart]');
      this.counter = this.querySelector('[data-counter]');
      this.donePanel = this.querySelector('[data-done-panel]');
      this.notes = Array.from(this.querySelectorAll('[data-note]'));

      this.hasDone = this.dataset.done === 'true' && this.donePanel != null;
      this.counterTemplate = this.dataset.counterTemplate || '{current} / {total}';
      this.doneLabel = this.dataset.doneLabel || '';
      this.index = 0;

      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      if (this.restartBtn) this.restartBtn.addEventListener('click', () => this.go(0));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
      });
      this.notes.forEach((note) => {
        const toggle = note.querySelector('[data-note-toggle]');
        if (toggle) toggle.addEventListener('click', () => this.toggleNote(note));
      });

      const bp = parseInt(this.dataset.breakpoint, 10) || 768;
      this.mql = window.matchMedia('(max-width: ' + bp + 'px)');
      this.onBreakpoint = () => this.sync();
      this.mql.addEventListener('change', this.onBreakpoint);
      this.sync();
    }

    disconnectedCallback() {
      if (this.mql) this.mql.removeEventListener('change', this.onBreakpoint);
    }

    // Stepper only takes over on small viewports and only when enabled in the editor.
    get compact() {
      return this.dataset.mode === 'stepper' && this.mql.matches && this.total > 0;
    }

    sync() {
      const on = this.compact;
      this.classList.toggle('is-compact', on);
      if (this.stepsEl) this.stepsEl.classList.toggle('is-stepper', on);
      if (this.controls) this.controls.hidden = !on;
      if (this.counter) this.counter.hidden = !on;

      if (on) {
        this.index = 0;
        this.render();
      } else {
        this.classList.remove('is-done');
        if (this.stepsEl) this.stepsEl.hidden = false;
        this.stepEls.forEach((step) => step.removeAttribute('aria-hidden'));
        if (this.donePanel) this.donePanel.hidden = true;
      }

      this.notes.forEach((note) => this.syncNote(note, on));
    }

    go(index) {
      const last = this.hasDone ? this.total : this.total - 1;
      this.index = Math.max(0, Math.min(index, last));
      this.render();
    }

    render() {
      const done = this.hasDone && this.index === this.total;
      this.classList.toggle('is-done', done);

      this.stepEls.forEach((step, i) => {
        const active = !done && i === this.index;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => {
        const active = !done && i === this.index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });

      // Collapse the step track in the done state, otherwise its min-height
      // leaves an empty gap above the confirmation panel.
      if (this.stepsEl) this.stepsEl.hidden = done;
      if (this.donePanel) this.donePanel.hidden = !done;
      if (this.dotsEl) this.dotsEl.hidden = done;
      if (this.nextBtn) this.nextBtn.hidden = done || (!this.hasDone && this.index >= this.total - 1);
      if (this.restartBtn) this.restartBtn.hidden = !done;
      if (this.counter) {
        this.counter.textContent = done
          ? this.doneLabel
          : this.counterTemplate.replace('{current}', String(this.index + 1)).replace('{total}', String(this.total));
      }
    }

    syncNote(note, compact) {
      const mode = note.dataset.collapse;
      const toggle = note.querySelector('[data-note-toggle]');
      const body = note.querySelector('[data-note-body]');
      if (!toggle || !body) return;

      const collapsible = mode === 'always' || (mode === 'mobile' && compact);
      note.classList.toggle('is-collapsible', collapsible);
      if (collapsible) {
        this.setNote(note, note.dataset.open === 'true');
      } else {
        note.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        body.hidden = false;
      }
    }

    setNote(note, open) {
      const toggle = note.querySelector('[data-note-toggle]');
      const body = note.querySelector('[data-note-body]');
      note.dataset.open = open ? 'true' : 'false';
      note.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.hidden = !open;
    }

    toggleNote(note) {
      if (!note.classList.contains('is-collapsible')) return;
      this.setNote(note, note.dataset.open !== 'true');
    }
  }

  if (!customElements.get('explainer-steps')) customElements.define('explainer-steps', ExplainerSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meter-tabs"] && !Shopify.designMode) return;
  try {
    
  /**
   * Tab switcher for the meter product page.
   *
   * Plain custom element rather than the theme `Component` base: there is no
   * server round trip and no shadow DOM involved, only local show/hide plus the
   * ARIA state and roving tabindex expected of a tablist.
   */
  class MeterTabs extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.tabs = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    select(index, { focus = false } = {}) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let target = null;

      switch (event.key) {
        case 'ArrowRight':
          target = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
          target = index === 0 ? last : index - 1;
          break;
        case 'Home':
          target = 0;
          break;
        case 'End':
          target = last;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.select(target, { focus: true });
    }
  }

  if (!customElements.get('meter-tabs')) {
    customElements.define('meter-tabs', MeterTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-rows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Geteilt mit dem Bento-Grid: einmal pro Seite initialisieren, egal welche Section das Skript bündelt.
    if (window.__bentoZoomInit) return;
    window.__bentoZoomInit = true;

    var overlay = null;
    var lbImg = null;
    var closeBtn = null;
    var activeTrigger = null;

    // Ein einziges Overlay für die ganze Seite, lazy beim ersten Öffnen erzeugt.
    function buildOverlay() {
      overlay = document.createElement('div');
      overlay.className = 'bento-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Bildansicht');
      overlay.hidden = true;

      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'bento-lightbox__close';
      closeBtn.setAttribute('aria-label', 'Schließen');
      closeBtn.innerHTML = '&times;';

      lbImg = document.createElement('img');
      lbImg.className = 'bento-lightbox__img';
      lbImg.alt = '';

      overlay.appendChild(closeBtn);
      overlay.appendChild(lbImg);
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      closeBtn.addEventListener('click', close);
    }

    // FLIP: Bild startet exakt auf der Thumbnail-Position und wächst zur Vollansicht.
    function flipFrom(first) {
      var last = lbImg.getBoundingClientRect();
      if (!last.width || !last.height) return;
      var dx = first.left - last.left;
      var dy = first.top - last.top;
      var sx = first.width / last.width;
      var sy = first.height / last.height;
      lbImg.style.transition = 'none';
      lbImg.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
      void lbImg.offsetWidth; // Reflow erzwingen
      requestAnimationFrame(function () {
        lbImg.style.transition = '';
        overlay.classList.add('is-visible');
        lbImg.style.transform = '';
      });
    }

    function open(trigger) {
      var thumb = trigger.querySelector('img');
      if (!thumb) return;
      if (!overlay) buildOverlay();
      activeTrigger = trigger;
      var first = thumb.getBoundingClientRect();
      overlay.hidden = false;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lbImg.alt = thumb.getAttribute('alt') || '';
      // Sofort die bereits geladene Thumbnail-Quelle nutzen → flüssige Animation.
      lbImg.src = thumb.currentSrc || thumb.src;
      var start = function () {
        flipFrom(first);
        // Danach hochauflösende Variante nachladen (gleiches Seitenverhältnis, kein Sprung).
        var hi = trigger.getAttribute('data-zoom-src');
        if (hi) {
          var pre = new Image();
          pre.onload = function () {
            if (activeTrigger === trigger) lbImg.src = hi;
          };
          pre.src = hi;
        }
      };
      if (lbImg.complete && lbImg.naturalWidth) start();
      else lbImg.addEventListener('load', start, { once: true });
      closeBtn.focus();
    }

    function close() {
      if (!activeTrigger) return;
      var trigger = activeTrigger;
      var thumb = trigger.querySelector('img');
      activeTrigger = null;
      var settle = function () {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
        lbImg.style.transition = 'none';
        lbImg.style.transform = '';
        lbImg.removeAttribute('src');
        document.body.style.overflow = '';
        if (trigger) trigger.focus();
      };
      if (!thumb) {
        overlay.classList.remove('is-visible');
        settle();
        return;
      }
      var first = thumb.getBoundingClientRect();
      var last = lbImg.getBoundingClientRect();
      var dx = first.left - last.left;
      var dy = first.top - last.top;
      var sx = first.width / last.width;
      var sy = first.height / last.height;
      overlay.classList.remove('is-visible');
      lbImg.style.transition = '';
      lbImg.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        settle();
      };
      lbImg.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 420); // Fallback, falls transitionend ausbleibt
    }

    // Event-Delegation: funktioniert für alle aktuellen und nachgeladenen Trigger.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-bento-zoom]');
      if (!trigger) return;
      e.preventDefault();
      open(trigger);
    });
    document.addEventListener('keydown', function (e) {
      if (!activeTrigger) return;
      if (e.key === 'Escape') {
        close();
      } else if (e.key === 'Tab') {
        // Einfacher Fokus-Trap: einziges Bedienelement ist der Schließen-Button.
        e.preventDefault();
        closeBtn.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
